import React from "react";
import { Link } from "react-router-dom";
import "./HeroBanner.css";
import { resolveAssetUrl } from "../utils/assets";

const HeroBanner = ({ data }) => {
  const bg = data?.backgroundImage
    ? resolveAssetUrl(data.backgroundImage) || data.backgroundImage
    : "";

  return (
    <section
      className="hero-banner"
      style={{ backgroundImage: bg ? `url(${bg})` : undefined }}
    >
      <div className="hero-content">
        {data?.badge && <span className="hero-badge">{data.badge}</span>}

        <h1>
          {data?.title} <br />
          {data?.titleLine2}
        </h1>

        {data?.tagline && <p className="hero-tagline">{data.tagline}</p>}

        {data?.features?.length > 0 && (
          <div className="hero-features">
            {data.features.map((feature) => (
              <span key={feature}>✓ {feature}</span>
            ))}
          </div>
        )}

        <div className="hero-buttons">
          {data?.primaryButtonText && (
            <Link to={data.primaryButtonLink || "/products"} className="shop-btn">
              {data.primaryButtonText}
            </Link>
          )}
          {data?.secondaryButtonText && (
            <Link
              to={data.secondaryButtonLink || "/products"}
              className="explore-btn"
            >
              {data.secondaryButtonText}
            </Link>
          )}
        </div>

        {data?.footerLine && (
          <p className="ecommerce-line">{data.footerLine}</p>
        )}
      </div>
    </section>
  );
};

export default HeroBanner;
